export const safetyStudyEnum = ["Faite", "Non faite"];

export const controlEnum = ["Fait", "Non fait"];

export const workTypeEnum = ["Neuf", "Rénovation"];

export const scndMaintenanceContractEnum = [
  "Acceptation",
  "Refus",
  "Continuité",
  "Fait (tout au-dessus)",
  "Non fait",
];

export const areaHourlyRatesEnum = {
  Neuf: {
    "Île-de-France Est": "54",
    "Île-de-France Ouest": "54",
    Alsace: "45",
    Lorraine: "45",
    Bretagne: "45",
    "Champagne-Ardennes": "45",
    Occitanie: "45",
    "Hauts-de-France": "45",
    "AGR Lyon": "45",
    "AGR Marseille": "45",
    Normandie: "45",
  },
  Rénovation: {
    "Île-de-France Est": "54",
    "Île-de-France Ouest": "54",
    Alsace: "45",
    Lorraine: "45",
    Bretagne: "45",
    "Champagne-Ardennes": "45",
    Occitanie: "45",
    "Hauts-de-France": "45",
    "AGR Lyon": "45",
    "AGR Marseille": "45",
    Normandie: "45",
  },
};

export const directPaymentEnum = ["Oui", "Non"];

export const areaEnum = [
  "Île-de-France Est",
  "Île-de-France Ouest",
  "Alsace",
  "Lorraine",
  "Bretagne",
  "Champagne-Ardennes",
  "Occitanie",
  "Hauts-de-France",
  "AGR Lyon",
  "AGR Marseille",
  "Normandie",
];

export const planEnum = ["Approuvés", "Non approuvés"];

export const areaColor = {
  "Île-de-France Est": "#AC4740",
  "Île-de-France Ouest": "#815b58",
  Alsace: "#4A90E2",
  Lorraine: "#3A953D",
  Bretagne: "#B34F93",
  "Champagne-Ardennes": "#AC7749",
  Occitanie: "#B1B143",
  "Hauts-de-France": "#489BA5",
  "AGR Lyon": "#9B51E0",
  "AGR Marseille": "#FF6B6B",
  Normandie: "#FF8400",
};

const makeUserSvg = (color) =>
  `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="${color}" d="M320 312C386.3 312 440 258.3 440 192C440 125.7 386.3 72 320 72C253.7 72 200 125.7 200 192C200 258.3 253.7 312 320 312zM290.3 368C191.8 368 112 447.8 112 546.3C112 562.7 125.3 576 141.7 576L498.3 576C514.7 576 528 562.7 528 546.3C528 447.8 448.2 368 349.7 368L290.3 368z"/></svg>`
  )}`;

export const areaPP = Object.fromEntries([
  ...Object.entries(areaColor).map(([area, color]) => [area, makeUserSvg(color)]),
  [null, makeUserSvg("#888888")],
]);

const makeCalcSvg = (color) =>
  `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="${color}" d="M192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 128C512 92.7 483.3 64 448 64L192 64zM224 128L416 128C433.7 128 448 142.3 448 160L448 192C448 209.7 433.7 224 416 224L224 224C206.3 224 192 209.7 192 192L192 160C192 142.3 206.3 128 224 128zM240 296C240 309.3 229.3 320 216 320C202.7 320 192 309.3 192 296C192 282.7 202.7 272 216 272C229.3 272 240 282.7 240 296zM320 320C306.7 320 296 309.3 296 296C296 282.7 306.7 272 320 272C333.3 272 344 282.7 344 296C344 309.3 333.3 320 320 320zM448 296C448 309.3 437.3 320 424 320C410.7 320 400 309.3 400 296C400 282.7 410.7 272 424 272C437.3 272 448 282.7 448 296zM216 416C202.7 416 192 405.3 192 392C192 378.7 202.7 368 216 368C229.3 368 240 378.7 240 392C240 405.3 229.3 416 216 416zM344 392C344 405.3 333.3 416 320 416C306.7 416 296 405.3 296 392C296 378.7 306.7 368 320 368C333.3 368 344 378.7 344 392zM424 416C410.7 416 400 405.3 400 392C400 378.7 410.7 368 424 368C437.3 368 448 378.7 448 392C448 405.3 437.3 416 424 416zM192 488C192 474.7 202.7 464 216 464L328 464C341.3 464 352 474.7 352 488C352 501.3 341.3 512 328 512L216 512C202.7 512 192 501.3 192 488zM424 464C437.3 464 448 474.7 448 488C448 501.3 437.3 512 424 512C410.7 512 400 501.3 400 488C400 474.7 410.7 464 424 464z"/></svg>`
  )}`;

export const areaInv = Object.fromEntries([
  ...Object.entries(areaColor).map(([area, color]) => [area, makeCalcSvg(color)]),
  [null, makeCalcSvg("#888888")],
]);

const makeWarnSvg = (color) =>
  `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="${color}" d="M320 64C334.7 64 348.2 72.1 355.2 85L571.2 485C577.9 497.4 577.6 512.4 570.4 524.5C563.2 536.6 550.1 544 536 544L104 544C89.9 544 76.8 536.6 69.6 524.5C62.4 512.4 62.1 497.4 68.8 485L284.8 85C291.8 72.1 305.3 64 320 64zM320 416C302.3 416 288 430.3 288 448C288 465.7 302.3 480 320 480C337.7 480 352 465.7 352 448C352 430.3 337.7 416 320 416zM320 224C301.8 224 287.3 239.5 288.6 257.7L296 361.7C296.9 374.2 307.4 384 319.9 384C332.5 384 342.9 374.3 343.8 361.7L351.2 257.7C352.5 239.5 338.1 224 319.8 224z"/></svg>`
  )}`;

export const areaRes = Object.fromEntries([
  ...Object.entries(areaColor).map(([area, color]) => [area, makeWarnSvg(color)]),
  [null, makeWarnSvg("#888888")],
]);

export const deadlines = {
  reserve: 2,
  stage: 2,
  plan: 16,
  cabin: 16,
  factory: 1,
  maintenance: 12,
  ce: 4,
  safety: 2,
};

/* export const deviceTypeEnum = [
  "Ascenseur de charge",
  "Ascenseur",
  "EPMR",
  "Chaise",
  "Monte-charge accessible",
  "Monte-charge accompagné",
  "Monte-charge non-accompagné",
  "Porte garage",
  "Porte piétonne",
  "Portail",
  "Porte souple",
]; */

export const deviceTypeEnum = [
  "Ascenseur",
  "Ascenseur de charge",
  "EPMR",
  "Monte-charge accessible",
  "Monte-charge inaccessible",
  "Monte-fût",
  "Monte-voiture",
  "Plateforme de charge",
  "Plateforme escalier",
  "Plaque tournante",
  "Monte-malade",
  "Monte-palette",
  "Portillon",
  "Porte",
  "Rideau",
  "Autre fermeture",
  "Barrière levante",
  "Portail battant",
  "Barrière",
  "Portail",
  "Porte de quai",
  "Porte garage",
  "Porte piétonne",
  "Porte sectionnelle",
  "Quai niveleur",
  "Rideau métallique",
  "Borne escamotable",
  "Chaise",
  "Interphone",
  "Porte vitrée",
  "Portail coulissant",
  "Porte souple",
];

/* export const deviceType = {
  "Ascenseur de charge": "ascenseur_de_charge",
  Ascenseur: "ascenseur",
  EPMR: "epmr",
  Chaise: "chaise",
  "Monte-charge accessible": "monte_charge_accessible",
  "Monte-charge accompagné": "monte_charge_accompagne",
  "Monte-charge non-accompagné": "monte_charge_non_accompagne",
  "Porte garage": "porte_garage",
  "Porte piétonne": "porte_pietonne",
  Portail: "portail",
  "Porte souple": "porte_souple",
}; */
export const deviceType = {
  Ascenseur: "ascenseur",
  "Ascenseur de charge": "ascenseur_de_charge",
  EPMR: "epmr",
  "Monte-charge accessible": "monte_charge_accessible",
  "Monte-charge inaccessible": "monte_charge_inaccessible",
  "Monte-fût": "monte_fut",
  "Monte-voiture": "monte_voiture",
  "Plateforme de charge": "plateforme_de_charge",
  "Plateforme escalier": "plateforme_escalier",
  "Plaque tournante": "plaque_tournante",
  "Monte-malade": "monte_malade",
  "Monte-palette": "monte_palette",
  Portillon: "portillon",
  Porte: "porte",
  Rideau: "rideau",
  "Autre fermeture": "autre_fermeture",
  "Barrière levante": "barriere_levante",
  "Portail battant": "portail_battant",
  Barrière: "barriere",
  Portail: "portail",
  "Porte de quai": "porte_de_quai",
  "Porte garage": "porte_garage",
  "Porte piétonne": "porte_pietonne",
  "Porte sectionnelle": "porte_sectionnelle",
  "Quai niveleur": "quai_niveleur",
  "Rideau métallique": "rideau_metallique",
  "Borne escamotable": "borne_escamotable",
  Chaise: "chaise",
  Interphone: "interphone",
  "Porte vitrée": "porte_vitree",
  "Portail coulissant": "portail_coulissant",
  "Porte souple": "porte_souple",
};

/* export const deviceTypes = [
  "tblsupplier.ascenseur_de_charge",
  "tblsupplier.ascenseur",
  "tblsupplier.epmr",
  "tblsupplier.chaise",
  "tblsupplier.monte_charge_accessible",
  "tblsupplier.monte_charge_accompagne",
  "tblsupplier.monte_charge_non_accompagne",
  "tblsupplier.porte_garage",
  "tblsupplier.porte_pietonne",
  "tblsupplier.portail",
  "tblsupplier.porte_souple",
]; */

export const deviceTypes = [
  "tblsupplier.ascenseur",
  "tblsupplier.ascenseur_de_charge",
  "tblsupplier.epmr",
  "tblsupplier.monte_charge_accessible",
  "tblsupplier.monte_charge_inaccessible",
  "tblsupplier.monte_fut",
  "tblsupplier.monte_voiture",
  "tblsupplier.plateforme_de_charge",
  "tblsupplier.plateforme_escalier",
  "tblsupplier.plaque_tournante",
  "tblsupplier.monte_malade",
  "tblsupplier.monte_palette",
  "tblsupplier.portillon",
  "tblsupplier.porte",
  "tblsupplier.rideau",
  "tblsupplier.autre_fermeture",
  "tblsupplier.barriere_levante",
  "tblsupplier.portail_battant",
  "tblsupplier.barriere",
  "tblsupplier.portail",
  "tblsupplier.porte_de_quai",
  "tblsupplier.porte_garage",
  "tblsupplier.porte_pietonne",
  "tblsupplier.porte_sectionnelle",
  "tblsupplier.quai_niveleur",
  "tblsupplier.rideau_metallique",
  "tblsupplier.borne_escamotable",
  "tblsupplier.chaise",
  "tblsupplier.interphone",
  "tblsupplier.porte_vitree",
  "tblsupplier.portail_coulissant",
  "tblsupplier.porte_souple",
];

export const statusEnum = [
  "Non facturée",
  "À facturer",
  "Facturée",
  "Partiellement payée",
  "Payée",
];

export const statusColor = {
  "Non facturée": "light",
  "À facturer": "error",
  Facturée: "warning",
  "Partiellement payée": "info",
  Payée: "success",
};

export const situationDescriptionEnum = [
  "Acompte à la commande",
  "Approvisionnement usine",
  "Réception de la gaine",
  "Livraison du matériel",
  "Début de montage",
  "En cours de montage",
  "Partie mécanique montée",
  "Partie électrique montée",
  "Fin de montage",
  "Levée des réserves",
  "Mise à disposition",
  "Remise des plans",
  "Remise DOE",
];

export const facesNumberEnum = ["1", "90°", "180°", "3"];

export const deviceStatusAdminEnum = [
  "À commander",
  "Gaine à relever",
  "À envoyer en fab",
  "En cours de fabrication",
  "Manque de ressources",
  "À faire livrer",
  "Stocké",
  "Montage",
  "CE à prévoir",
  "Réserves à lever",
  "MAD à prévoir",
  "MAD",
  "Cloturé",
];

export const deviceStatusRandomEnum = [
  "À commander",
  "Gaine à relever",
  "À envoyer en fab",
  "En cours de fabrication",
  "Manque de ressources",
  "À faire livrer",
  "Stocké",
  "Montage",
  "CE à prévoir",
  "Réserves à lever",
  "MAD à prévoir",
  "MAD",
];

export const userRoleEnum = [
  "Admin",
  "Direction",
  "Chef d'agence",
  "Pilote",
  "Contremaître",
  "Technicien",
  "Sous-Traitant",
  "Commercial",
  "Assistante de gestion",
];

export const roleExpEnum = {
  Admin: "L'utilisateur aura accès à toutes les données, et pourra tout modifier",
  Direction: "L'utilisateur aura accès à toutes les données, et ne pourra rien modifier",
  "Chef d'agence": "L'utilsateur aura accès aux données de son agence, et pourra modifier les commandes de son agence",
  Pilote: "L'utilisateur aura accès à toutes les données, et pourra tout modifier",
  Contremaître:
    "L'utilisateur aura accès aux affaires lui appartenant et pourra effectuer des modifications non financières",
  Technicien: "L'utilisateur aura accès à son planning",
  "Sous-Traitant": "L'utilisateur aura accès à son planning",
  Commercial:
    "L'utilisateur aura accès aux affaires sur lequelles il est cité. S'il est cité en tant que Commercial Projet, il ne pourra rien modifier, s'il est cité en tant que Commercial Service, il pourra modifier les informations qui concernent le contrat de maintenance",
  "Assistante de gestion":
    "L'utilisateur aura accès à toutes les données et pourra modifier les informations de comptabilité",
};

export const maintenanceContractEnum = ["Proposition", "Acceptation", "Refus", "Continuité"];

export const absenceEnum = ["Déplacement", "Arrêt", "Congé"];
